export const filterImagesByFileName = (images, fileName) => {
  const filteredImages = []
  if (images && images.length > 0) {
    for (const image of images) {
      if (image.sizes && fileName && image.sizes[fileName]) {
        filteredImages.push({
          ...image,
          displayImage: image.sizes[fileName].src,
          displayWidth: image.sizes[fileName].width,
          displayHeight: image.sizes[fileName].height
        })
      } else {
        filteredImages.push({
          ...image,
          displayImage: image.file
        })
      }
    }
  }

  return filteredImages
}
